import * as types from 'store/modules/hres6ju/mutation-types'
import hres6ju from 'api/hres6ju'
import swal from 'sweetalert'
import hres6juLabels from 'assets/labels/hres6ju'
import { hres6juMaxRowspan, hres6juColumns } from 'assets/columns/hres6ju'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6juLabels,
    maxRowspan: hres6juMaxRowspan,
    columns: hres6juColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {}
    },
    popupTab1: {
      table1: {
        total: 0,
        rows: []
      },
      table2: {
        total: 0,
        rows: []
      }
    },
    dropdowns: {
      codtparg: {
        en: {},
        th: {}
      },
      codcours: {
        en: {},
        th: {}
      },
      numclseq: {
        en: {},
        th: {}
      },
      codplan: {
        en: {},
        th: {}
      },
      dtemonth: {
        en: {},
        th: {}
      }
    },
    approve: {},
    training: {
      table: {
        total: 0,
        rows: []
      }
    },
    indexSelected: [],
    detailSubmit: {
      tab1: {}
    },
    courseDetail: {}
  },
  getters: {
    [types.GET_HRES6JU_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6JU_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6JU_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES6JU_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6JU_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6JU_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6JU_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6JU_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES6JU_DETAIL_POPUP] (state) {
      return state.popupTab1
    },
    [types.GET_HRES6JU_TRAINING] (state) {
      return state.training
    },
    [types.GET_HRES6JU_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRES6JU_DETAIL_SUBMIT] (state) {
      return state.detailSubmit
    },
    [types.GET_HRES6JU_COURSE_DETAIL] (state) {
      return state.courseDetail
    }
  },
  mutations: {
    [types.SET_HRES6JU_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6JU_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6JU_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].tab1PopupTable1 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab1PopupTable1, labels[keyLang])
        state.columns[keyLang].tab1PopupTable2 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab1PopupTable2, labels[keyLang])
        state.columns[keyLang].popupTrainingTable = configLabel.replaceLabelToColumns(state.columns[keyLang].popupTrainingTable, labels[keyLang])
      }
    },
    [types.SET_HRES6JU_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES6JU_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6JU_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6JU_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRES6JU_DETAIL_POPUP] (state, popupTab1) {
      state.popupTab1 = popupTab1
    },
    [types.SET_HRES6JU_TRAINING] (state, training) {
      state.training = training
    },
    [types.SET_HRES6JU_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRES6JU_DETAIL_SUBMIT] (state, data) {
      state.detailSubmit = data
    },
    [types.SET_HRES6JU_COURSE_DETAIL] (state, data) {
      state.courseDetail = data
    },
    [types.SET_HRES6JU_NUMCLSEQ] (state, data) {
      state.dropdowns.numclseq = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6JU_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6JU_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6JU_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6JU_COLUMNS_LABELS] ({ commit }) {
      hres6ju.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_COLUMNS, data.labels)
          commit(types.SET_HRES6JU_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_INDEX] ({ commit }, searchParams) {
      hres6ju.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_DETAIL] ({ commit }, detailParams) {
      hres6ju.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_DETAIL_POPUP] ({ commit }, popupParams) {
      hres6ju.getDetailPopup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_DETAIL_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_DROPDOWNS] ({ commit }, dropdownParams) {
      hres6ju.getDropdowns(dropdownParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_TRAINING] ({ commit }, trainingParams) {
      hres6ju.getTraining(trainingParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_TRAINING, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_DETAIL_SUBMIT] ({ commit }, detailParams) {
      hres6ju.getDetailSubmit(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_DETAIL_SUBMIT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_NUMCLSEQ] ({ commit }, detailParams) {
      hres6ju.getNumclseq(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_NUMCLSEQ, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6JU_COURSE_DETAIL] ({ commit }, detailParams) {
      hres6ju.getCourseDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6JU_COURSE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES6JU_SEND_APPROVE] ({ commit, dispatch }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          let referenceButton = params.referenceButton
          hres6ju.postSendApprove(params.approveParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            dispatch(types.RECEIVED_HRES6JU_INDEX, {})
            dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
            swal({title: '', text: data.response, html: true, type: 'success'}, function () {
              referenceButton.click()
            })
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6ju/index.js